import { combineReducers as _combineReducers, Reducer, ReducersMapObject } from 'redux';

export const combineReducers: <S = never>(reducers: ReducersMapObject<S, any>) => Reducer<S> =
  _combineReducers;
